import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';
import { navigateTo } from 'Helpers/Redirect';
import { loginPath } from 'Consts/Strings';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
});

const BackToLoginButton = ({
  className,
  classes,
}) => {
  return (
    <TextButton
      className={classNames(classes.root, className)}
      onClick={() => navigateTo(loginPath)}
      fullWidth
      test={'back-to-login-button'}
    >
      {'Go Back'}
    </TextButton>
  );
};

BackToLoginButton.defaultProps = {
  className: '',
};

BackToLoginButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BackToLoginButton);
